import Service from "../../Models/Service";
import { ServiceType } from "../../Models/ServiceType";
import OrderHandler from "./OrderHandler";

export default class OrderValidator {
	private static tagCode: HTMLInputElement = document.querySelector('.tagcode input');
	private static storeSelect: HTMLSelectElement = document.querySelector(".store-select select");
	private static deliverHomeCheckBox: HTMLInputElement = document.querySelector('#deliver-home');
	private static emailInput: HTMLInputElement = document.querySelector('#create-customer-inputs input[name="email"]');
	private static terms: HTMLInputElement = document.querySelector("#terms");

	public static get isValidOrder(): boolean {
		return this.IsValidItems
			&& this.isValidDate
			&& this.isValidTagCode
			&& this.isValidStore
			&& this.isValidAddress
			&& this.isValidCustomer
			&& this.hasReadAndCheckedTerms;
	}

	public static get IsValidItems(): boolean {
		return OrderHandler.order.items.length > 0;
	}

	public static get isValidDate(): boolean {
		return OrderHandler.order.deliveryDate instanceof Date;
	}

	public static get isValidTagCode(): boolean {
		return !this.tagCode || !!OrderHandler.order.tagCode;
	}

	public static get isValidStore(): boolean {
		return !this.storeSelect || !!OrderHandler.order.storeId;
	}

	public static get isValidAddress(): boolean {
		return !this.deliverHomeCheckBox
			|| !this.deliverHomeCheckBox.checked
			|| !!OrderHandler.order.customerAddress;
	}

	public static get isValidCustomer(): boolean {
		return OrderHandler.order.customerName != null
			&& OrderHandler.order.customerPhoneNumber != null
			&& this.isValidEmail;
	}

	public static isValidService(service: Service): boolean {
		let hasVariants = service.variants.length > 0;

		if (service.type === ServiceType.Canvas) {
			return service.imageSrc && hasVariants;
		}

		return hasVariants;
	}

	public static get hasReadAndCheckedTerms(): boolean {
		return !this.terms || this.terms.checked;
	}

	private static get isValidEmail(): boolean {
		if (OrderHandler.isDibsEnabled) {
			return OrderHandler.order.customerEmail != null;
		}

		return !this.emailInput.value.trim() || OrderHandler.order.customerEmail != null;
	}
}
